import { hasComplexArrayItems as e } from "./has-complex-array-items.js";
import { isArraySchema as t } from "@scalar/workspace-store/schemas/v3.2/strict/type-guards";
//#region src/schema/helpers/should-render-array-item-composition.ts
var n = (n, r) => {
	if (!n || !t(n)) return !1;
	let i = n.items;
	return !i || typeof i != "object" || !(r in i) ? !1 : !e(n);
};
//#endregion
export { n as shouldRenderArrayItemComposition };

//# sourceMappingURL=should-render-array-item-composition.js.map